export enum CaseType {
  NORMAL = 'Normal',
  DISCREPANCY = 'Discrepancy',
}

export interface GetAnnotationCasePayload {
  tenancyId: number;
  caseType: CaseType;
}

export enum QuestionType {
  NORMAL = 'AutoMedic Annotation Feedback Normal',
  DISCREPENCY = 'AutoMedic Annotation Feedback Discrepancy',
}

export type ObservationHeader = {
  id: string;
  label: string;
  date: string;
};

export type ObservationValue = {
  name: string;
  values: string[];
  interpretations: any[];
  ranges: any[];
  units: any[];
};
